import { useContext, useState, useEffect } from "react";
import { Context_UI } from "../../Contexts/Context_UI"
import UI_Button from "./UI_Button";
import UI_Icon from "./UI_Icons";

function pad(n) {
    return String(n).padStart(2, "0");
}

function getNowFormatted(inputType) {
    const d = new Date();
    const year = d.getFullYear();
    const month = pad(d.getMonth() + 1);
    const day = pad(d.getDate());
    const hours = pad(d.getHours());
    const minutes = pad(d.getMinutes());
    const seconds = pad(d.getSeconds());

    switch (inputType) {
        case "date":
            // YYYY-MM-DD
            return `${year}-${month}-${day}`;
        case "time":
            // HH:MM (you can add :SS if you want seconds)
            return `${hours}:${minutes}`;
        case "datetime-local":
            // YYYY-MM-DDTHH:MM
            return `${year}-${month}-${day}T${hours}:${minutes}`;
        default:
            return "";
    }
}

export default function UI_Input_Text({
    id,
    Input_Type = "text",
    Input_Placeholder,
    Label_Text,
    onInput,
    onSubmit,
    onKeyDown,
    Value,
    Value_Set_Enable,
    onChange,
    onBlur,
    onClick,
    autoFocus,
    onFocus,
    disabled,
    Classes,
    min,
    max,
    PreventPast,
    Required,
    name
}) {
    const UI = useContext(Context_UI);
    

    // internal state for controlled mode
    const [Value_Internal, Value_Internal_Set] = useState(() => {
        // prefer provided Value when present; else use current date/time for date/time/datetime-local
        if (Value_Set_Enable) {
            if (Value !== undefined && Value !== null && Value !== "") return Value;
            if (["date", "datetime-local"].includes(Input_Type)) {
                return getNowFormatted(Input_Type);
            }
            return Value || "";
        }
        return ""; // uncontrolled mode uses defaultValue instead
    });
    const [ShowPassword, ShowPassword_Set] = useState(false);

    // sync external Value -> internal when controlled
    useEffect(() => {
        if (!Value_Set_Enable) return;
        if (Value !== undefined && Value !== null && Value !== "") {
            Value_Internal_Set(Value);
        } else if (["date", "datetime-local"].includes(Input_Type)) {
            // If parent intentionally provides empty/undefined value, set current time as fallback
            Value_Internal_Set(getNowFormatted(Input_Type));
        } else {
            Value_Internal_Set(Value || "");
        }
    }, [Value, Value_Set_Enable, Input_Type]);

    const Handle_Input_Change = (e) => {
        const Value_New = e.target.value;
        if (Value_Set_Enable) {
            // controlled input: update internal state
            Value_Internal_Set(Value_New);
        }
        if (onChange) onChange(e);
    };

    const Handle_Input = (e) => {
        if (onChange) {
            onChange(e);
        }
        if (onInput) {
            onInput(e);
        }
    }

    // label htmlFor fix
    return (
        <>
            
            {Label_Text ? (
                <label className="Input_Label" htmlFor={id}>
                    {Label_Text}{Required ? <p className="Input_Label_Required">*</p> : ""}
                </label>
            ) : null}

            <div className={`Input_Wrapper ${Input_Type === "password" ? "Input_Wrapper_Password" : ""}`}>
                {Value_Set_Enable ? (
                    <input
                        type={Input_Type === "password" && ShowPassword ? "text" : Input_Type}
                        className={`Input_Text ${Classes || ""}`}
                        placeholder={Input_Placeholder}
                        id={id}
                        onKeyDown={onKeyDown}
                        onInput={Handle_Input}
                        onChange={Handle_Input}
                        onClick={onClick}
                        onFocus={onFocus}
                        onBlur={onBlur}
                        autoFocus={!!autoFocus}
                        disabled={disabled}
                        value={Value_Internal}
                        min={PreventPast && Input_Type == "date" ? getNowFormatted("date") : min || null}
                        max={max || null}
                        step={Input_Type === "time" ? 900 : undefined}
                        name={name}
                    />
                ) : (
                    <input
                        type={Input_Type === "password" && ShowPassword ? "text" : Input_Type}
                        className={`Input_Text ${Classes || ""}`}
                        placeholder={Input_Placeholder}
                        id={id}
                        onKeyDown={onKeyDown}
                        onInput={onInput}
                        onChange={onChange}
                        onBlur={onBlur}
                        autoFocus={!!autoFocus}
                        disabled={disabled}
                        min={PreventPast && Input_Type == "date" ? getNowFormatted("date") : min || null}
                        max={max || null}
                        name={name}
                        step={Input_Type === "time" ? 900 : undefined}
                        defaultValue={
                            (Value !== undefined && Value !== null && Value !== "")
                                ? Value
                                : ["date", "time", "datetime-local"].includes(Input_Type)
                                    ? getNowFormatted(Input_Type)
                                    : Value
                        }
                    />
                )}

                

                {/* Add show/hide password button */}
                {Input_Type === "password" && (
                    <UI_Button
                        Type="Text"
                        OnClick={() => ShowPassword_Set(prev => !prev)}
                        style={{
                            position: "absolute",
                            right: "10px",
                            fontSize: "12px",
                            padding: "2px 6px",
                            cursor: "pointer"
                        }}
                        // Text={ShowPassword ? "Hide" : "Show"}
                        Icon={ShowPassword ? <UI_Icon Name="Unsee" /> : <UI_Icon Name="See" />}
                        Icon_Position="Center"
                        className="Input_Text_Password_Toggle"
                    >
                        {/* {ShowPassword ? "Hide" : "Show"} */}
                    </UI_Button>
                )}

                <p className="Input_Text_Prompt" id={`${id}_Prompt`}></p>
            </div>

            
        </>

    );
}
